module.exports = __webpack_public_path__ + "static/media/sprite.8c854a9a.svg";